const promotion = '/api/promotion'
const promotionFlyers = '/api/promotion-flyer'

export { promotion, promotionFlyers }
